import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../apis/EdisonApi";

const fields = [
	{ name: "pv_threshold", label: "PV threshold", unit: "%" },
	{ name: "batt_active_threshold", label: "Battery activation threshold", unit: "%" },
	{ name: "batt_deactive_threshold", label: "Battery deactivation threshold", unit: "%" },
	{ name: "last_event_delay", label: "Delay after last event", unit: "s" },
	{ name: "TTL", label: "Historical data retention", unit: "s" },
];

const initialValues = fields.reduce((values, field) => ({ ...values, [field.name]: "" }), {});

const Thresholds = () => {
	const [thresholds, setThresholds] = useState(null);
	const [values, setValues] = useState(initialValues);
	const [isSaving, setIsSaving] = useState(false);

	useEffect(() => {
		const controller = new AbortController();

		api.get("/settings/status", { signal: controller.signal })
			.then((response) => setThresholds(response.data))
			.catch((error) => {
				if (error.name !== "CanceledError") toast.error("API error getting thresholds");
			});

		return () => controller.abort();
	}, []);

	const handleChange = (event) => {
		const { name, value } = event.target;
		setValues((currentValues) => ({ ...currentValues, [name]: value }));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		const body = Object.fromEntries(
			Object.entries(values)
				.filter(([, value]) => value !== "")
				.map(([key, value]) => [key, Number(value)])
		);

		if (Object.keys(body).length === 0) {
			toast.info("Change at least one threshold before saving");
			return;
		}

		try {
			setIsSaving(true);
			await api.post("/settings/thresholds", body);
			setThresholds((current) => ({ ...current, ...body }));
			setValues(initialValues);
			toast.success("Thresholds saved successfully");
		} catch {
			toast.error("API error setting thresholds");
		} finally {
			setIsSaving(false);
		}
	};

	return (
		<div className="x_content">
			<form className="threshold-form" onSubmit={handleSubmit}>
				<div className="threshold-form__grid">
					{fields.map((field) => (
						<div className="form-group" key={field.name}>
							<label htmlFor={field.name}>{field.label} ({field.unit})</label>
							<input
								className="form-control"
								id={field.name}
								name={field.name}
								type="number"
								value={values[field.name]}
								onChange={handleChange}
								placeholder={thresholds?.[field.name] ?? "Not available"}
							/>
						</div>
					))}
				</div>
				<button type="submit" className="btn btn-primary settings-save-button" disabled={isSaving}>
					{isSaving ? "Saving…" : "Save changes"}
				</button>
			</form>
		</div>
	);
};

export default Thresholds;
